import React, { createContext, useState } from "react";
export const NumberOfficialMonitorContext = createContext();

const NumberOfficialMonitorProvider = ({ children }) => {
  const [monitorOfficialFilter, setMonitorOfficialFilter] = useState({
    sector: "",
    server: { label: "", value: "" },
    client: { label: "", value: "" },
    number: "",
  });
  return (
    <NumberOfficialMonitorContext.Provider
      value={{ monitorOfficialFilter, setMonitorOfficialFilter }}
    >
      {children}
    </NumberOfficialMonitorContext.Provider>
  );
};

export { NumberOfficialMonitorProvider };
